(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/shared/fallback.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/shared/fallback.js');

'use strict';

const {
  useAtomValue,
  useSetAtom
} = jotai;
const {
  activeMethodAtom,
  showFallbackQrAtom,
  showLoaderAtom,
  showFallbackAtom
} = svs.iam_idp.atoms;
const {
  Button
} = svs.ui;
const {
  isPnp
} = svs.iam_idp.data;
const Fallback = () => {
  const setShowFallbackQr = useSetAtom(showFallbackQrAtom);
  const setShowLoader = useSetAtom(showLoaderAtom);
  const setShowFallback = useSetAtom(showFallbackAtom);
  const activeMethod = useAtomValue(activeMethodAtom);
  const handleClick = () => {
    setShowLoader(true);
    setShowFallback(false);
    setShowFallbackQr(true);
  };
  return React.createElement("div", {
    className: "margin-xs-top-2 fade-in align-center"
  }, React.createElement("div", null, React.createElement("p", null, "F\xF6rs\xF6ker starta", ' ', activeMethod.methodName, "-appen"), React.createElement(Button, {
    block: true,
    className: "margin-top-4 margin-bottom-1",
    iconPosition: "left",
    inverted: isPnp,
    onClick: handleClick,
    size: 300,
    transparent: true
  }, "Logga in p\xE5 annan enhet")));
};
svs.iam_idp.components.shared.Fallback = Fallback;

 })(window);